import { storeType } from '../redux/store';
import { ActionTypes } from '../redux/actions/types';

export const handle4xx = (store: storeType, err: any) => {
  const messages = err.response.data;
  store.dispatch({
    type: ActionTypes.ADD_NOTIFICATIONS,
    payload: messages,
  });
};
